/*
  Lazy YouTube facade. The poster and play button are static markup; the iframe
  is only created once someone asks for it. Keeps three films on one page cheap.
*/
(function () {
  function play(facade) {
    var id = facade.getAttribute('data-alepu-video');
    if (!id || facade.classList.contains('is-playing')) return;

    var iframe = document.createElement('iframe');
    iframe.src =
      'https://www.youtube-nocookie.com/embed/' +
      encodeURIComponent(id) +
      '?autoplay=1&rel=0&modestbranding=1&playsinline=1';
    iframe.title = facade.getAttribute('data-alepu-video-title') || 'Video';
    iframe.allow = 'accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture';
    iframe.allowFullscreen = true;
    iframe.className = 'alepu-facade__frame';
    iframe.setAttribute('loading', 'lazy');

    facade.classList.add('is-playing');
    facade.appendChild(iframe);
    iframe.focus();
  }

  function bind(root) {
    (root || document).querySelectorAll('[data-alepu-video]').forEach(function (facade) {
      if (facade.dataset.alepuBound) return;
      facade.dataset.alepuBound = 'true';
      facade.addEventListener('click', function () {
        play(facade);
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener(
      'DOMContentLoaded',
      function () {
        bind();
      },
      { once: true },
    );
  } else {
    bind();
  }

  document.addEventListener('shopify:section:load', function (event) {
    bind(event.target);
  });
})();
